// extracted by mini-css-extract-plugin
export default {"container":"RecordListSearch_container__e1U3H","search":"RecordListSearch_search__Be5vZ"};